import { Check } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'

import { THEME_OPTIONS } from './theme-options'
import { ThemePreview } from './theme-preview'

/** appearance card for the settings page. light / dark, persisted to
 * localStorage by next-themes (see the ThemeProvider in main).
 */
export function ThemeSetting() {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)
  /** theme is undefined until next-themes reads localStorage on the client.
   * gate the active highlight so it never paints the wrong option for a frame.
   */
  useEffect(() => setMounted(true), [])

  return (
    <div className='flex w-full flex-col gap-4 rounded-2xl border border-border bg-page p-6'>
      <div>
        <h2 className='text-[16px] font-semibold text-ink'>Theme</h2>
        <p className='mt-0.5 text-[13px] text-ink-soft'>
          Applies to this browser only, not to your account.
        </p>
      </div>

      <div className='grid gap-3 sm:max-w-lg sm:grid-cols-2'>
        {THEME_OPTIONS.map(option => {
          const Icon = option.icon
          const active = mounted && theme === option.value
          return (
            <button
              key={option.value}
              type='button'
              onClick={() => setTheme(option.value)}
              aria-pressed={active}
              className={`group cursor-pointer rounded-xl border p-2 text-left transition-colors ${
                active
                  ? 'border-accent ring-2 ring-accent/25'
                  : 'border-border hover:border-ink-muted'
              }`}
            >
              <ThemePreview theme={option.value} />
              <span className='flex items-center gap-2 px-1 pt-2 pb-0.5'>
                <Icon
                  className={`size-4 ${active ? 'text-accent' : 'text-ink-soft'}`}
                />
                <span
                  className={`flex-1 text-[13px] ${
                    active ? 'font-medium text-ink' : 'text-ink-soft'
                  }`}
                >
                  {option.label}
                </span>
                {active && (
                  <span className='flex size-4 items-center justify-center rounded-full bg-accent'>
                    <Check className='size-2.5 text-white' strokeWidth={3} />
                  </span>
                )}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
